import React from 'react';

export default ({ color = 'white', size = 10 }: { color?: string; size?: number }) => (
<svg width={size} height={size} viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M7.625 2.72656L10.125 5.22656"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4.08333 11.2675L0.75 12.1008L1.58333 8.7675L9.08333 1.2675C9.77333 0.5775 10.8933 0.5775 11.5833 1.2675C12.2733 1.9575 12.2733 3.0775 11.5833 3.7675L4.08333 11.2675Z"
      stroke="#8D8F92"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
</svg>
);
